import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledDisclaimer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 16px;
  ${setFontVariant('tooltip', colorsPalettes.carbon[300])};
  line-height: 14px;
  flex-shrink: 0;
`;

export const StyledDisclaimerLink = styled.a`
  color: ${colorsPalettes.blue[300]};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledDisclaimerInfoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
`;
